import { authApiCall } from '../auth/saga';

export const getCJDeals = (params) =>
  authApiCall({
    url: '/affiliate-coupons/cj-deals/',
    method: 'get',
    params,
  });

export const getCJAdvertisers = () =>
  authApiCall({
    url: '/affiliate-coupons/cj-advertisers/',
    method: 'get',
  });

export const getCJProductImages = (params) =>
  authApiCall({
    url: '/affiliate-coupons/cj-product-images/',
    method: 'get',
    params,
  });

export const getCJSaleProducts = (params) =>
  authApiCall({
    url: '/affiliate-coupons/cj-sale-products/',
    method: 'get',
    params,
  });